import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { forwardRef, useContext, useEffect, useMemo, useRef, useState } from 'react';
import CustomSelect2 from './CustomSelect2';
import { Box, Typography, FormControlLabel, Grid, Checkbox, TextField, InputAdornment, Select, MenuItem, colors, Snackbar, Button } from '@mui/material';
import SelectPlanCheckbox from './SelectPlanCheckbox';
import { ConfigContext } from '../utils/ConfigContext';
import TableRatesRow from './TableRatesRow';
import getSafe from '../utils/getSafe';
import domtoimage from 'dom-to-image';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { styled } from '@mui/material/styles';
import PercentInput from './PercentInput';
import NotesDisplay from './NotesDisplay';
import RatesVersionSelect from './RatesVersionSelect';
import TableViewModeToggleButton from './TableViewModeToggleButton';
import CopyImageButton from './CopyImageButton';
import TableCellRate from './TableCellRate';
import TableCellText from './TableCellText';
import TableCellRateSubtotalPerPlan from './TableCellRateSubtotalPerPlan';
import _ from 'lodash';
import CopyExcelDataButton from './CopyExcelDataButton';
import ChecklistIcon from '@mui/icons-material/Checklist';
import TableOfBenefitsDialog from './TableOfBenefitsDialog';
import FactCheckIcon from '@mui/icons-material/FactCheck';




const Lifeline_Rates = forwardRef(({ appConfig, sx, clients, currency, _currency, selectedPlans,
  setSelectedPlans, loadingStatus, response, setResponse, deductibles, setDeductibles,
  addToPendingTasks, discounts, setDiscounts, loadings, setLoadings, computedRates,
  setComputedRates, specificAreaOfCoverage, setSpecificAreaOfCoverage, areaOfCoverage,
  setShowImageCopy, selectedOptions, addSelectedOption,
  setViewSelectedOption, specificCurrency, setSpecificCurrency,
  specificPaymentFrequency, setSpecificPaymentFrequency,
  isExpandedApiRequestPerInsurers, setIsxpandedApiRequestPerInsurers,
  tableOfBenefits, fetchTOB_Data, fetchingTOB_Data, insurerRates = [], selectedRatesVersion, setSelectedRatesVersion, handleFetchAppConfig, setShowRefreshNow }, ref) => {

  const id = 'lifeline';

  // const { appConfig } = useContext(ConfigContext);

  const containerRef = useRef(null);


  const lifelinePlans = ['lifeline_essential', 'lifeline_classic', 'lifeline_gold'];

  const specific_area_of_coverages = getSafe(() => appConfig.content.set2_area_of_coverage);

  const currencies = getSafe(() => appConfig.content.currencies, []);
  // const currencies = ["USD", "SGD"];

  const [assistanceCovers, setAssistanceCovers] = useState({
    evacuation: false,
    repatriation: false
  });

  const [isSelecting, setIsSelecting] = useState(false);
  const [startCell, setStartCell] = useState(null);
  const [endCell, setEndCell] = useState(null);

  const [openTableOfBenefitsDialog, setOpenTableOfBenefitsDialog] = useState(false);

  useEffect(() => {
    computedRates[id] = getComputedRates();
    setComputedRates(computedRates);
  }, [response, discounts, loadings]);


  useEffect(() => {
    setTimeout(() => {
      addSelectedOption(id, 'specific_area_of_coverage', specificAreaOfCoverage[id]);
      addSelectedOption(id, 'specific_currency', specificCurrency[id]);
      addSelectedOption(id, 'specific_payment_frequency', specificPaymentFrequency[id]);
      addSelectedOption(id, 'deductible', deductibles[id]);
      addSelectedOption(id, 'discount', discounts[id] == '' ? 0 : discounts[id]);
      addSelectedOption(id, 'loading', loadings[id] == '' ? 0 : loadings[id]);
      addSelectedOption(id, 'evacuation', assistanceCovers.evacuation);
      addSelectedOption(id, 'repatriation', assistanceCovers.repatriation);
    }, 1000);

  }, [assistanceCovers.evacuation, assistanceCovers.repatriation, specificAreaOfCoverage[id], specificCurrency[id], specificPaymentFrequency[id], deductibles[id], discounts[id], loadings[id]]);

  useEffect(() => {
    setViewSelectedOption(id, 'deductible', (option_value) => {
      deductibles[id] = option_value;
      setDeductibles(deductibles);
    });
    setViewSelectedOption(id, 'discount', (option_value) => {
      discounts[id] = option_value;
      setDiscounts(discounts);
    });

    setViewSelectedOption(id, 'loading', (option_value) => {
      loadings[id] = option_value;
      setDiscounts(loadings);

    });

    setViewSelectedOption(id, 'specific_area_of_coverage', (option_value) => {
      specificAreaOfCoverage[id] = option_value;
      setSpecificAreaOfCoverage(specificAreaOfCoverage);
      // console.log(specificAreaOfCoverage, option_value);
    });

    setViewSelectedOption(id, 'specific_currency', (option_value) => {
      specificCurrency[id] = option_value;
      setSpecificCurrency(specificCurrency);
      // console.log(option_value)
    });

    setViewSelectedOption(id, 'specific_payment_frequency', (option_value) => {
      specificPaymentFrequency[id] = option_value;
      setSpecificPaymentFrequency(specificPaymentFrequency);
    });

    setViewSelectedOption(id, 'evacuation', (option_value) => {
      assistanceCovers.evacuation = option_value == 1;
      setAssistanceCovers(assistanceCovers);
    });

    setViewSelectedOption(id, 'repatriation', (option_value) => {
      assistanceCovers.repatriation = option_value == 1;
      setAssistanceCovers(assistanceCovers);
    });
  }, [selectedOptions]);


  function getComputedRates() {
    if (!response) return;

    const rates = response.rates;
    const assistance_cover_rates = response.assistance_covers;
    const discount = parseFloat(discounts[id]) || 0;
    const loading = parseFloat(loadings[id]) || 0;
    const totalPercent = ((100 - discount + loading) * 0.01);


    const computedRates = [];

    for (let i = 0; i < rates.length; i++) {
      const computedRate = {
        'client': rates[i].client,
        'currency': rates[i].currency,
        'essential': rates[i].essential * totalPercent,
        'classic': rates[i].classic * totalPercent,
        'gold': rates[i].gold * totalPercent,
        'evacuation': assistance_cover_rates[i].evacuation,
        'repatriation': assistance_cover_rates[i].repatriation,
      };

      const rates_per_deductibles = {};

      if (isExpandedApiRequestPerInsurers[id]) {
        for (const deductible in rates[i]?.rates_per_deductibles) {
          rates_per_deductibles[deductible] = {};
          for (const plan in rates[i]?.rates_per_deductibles?.[deductible]) {
            rates_per_deductibles[deductible][plan] = rates[i]?.rates_per_deductibles?.[deductible]?.[plan] * totalPercent;
          }
        }
      }

      computedRate['rates_per_deductibles'] = rates_per_deductibles;

      computedRates.push(computedRate)
    }

    return computedRates;
  }

  function handleDeductibleChange(e) {
    const _deductibles = JSON.parse(JSON.stringify(deductibles));

    _deductibles.lifeline = e.target.value;

    setDeductibles(_deductibles);

    // clearResponse();

    addToPendingTasks([id]);
  }

  function checkIfThereIsSelectedLifelinePlan() {
    for (let i = 0; i < selectedPlans.length; i++) {
      if (lifelinePlans.includes(selectedPlans[i])) {
        return true;
      }
    }

    return false;
  }

  function scrollToView() {
    // setTimeout(() => {
    //   containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // }, 200);
  }

  // function onInputDiscountChange(e) {
  //   let value = e.target.value;

  //   // Allow only numbers and at most one decimal point
  //   value = value.replace(/[^0-9.]/g, '');

  //   // Prevent multiple decimals
  //   if ((value.match(/\./g) || []).length > 1) {
  //     value = value.substring(0, value.lastIndexOf('.'));
  //   }

  //   // Ensure only two decimal places
  //   if (value.includes('.')) {
  //     const [integerPart, decimalPart] = value.split('.');
  //     value = `${integerPart}.${decimalPart.substring(0, 2)}`;
  //   }

  //   // Remove leading zeros (but allow "0" or "0.x" scenarios)
  //   if (value !== '' && value !== '0' && value.startsWith('0') && !value.startsWith('0.')) {
  //     value = value.replace(/^0+/, '');
  //   }

  //   // Limit value to a maximum of 100
  //   if (parseFloat(value) > 100) {
  //     value = '100';
  //   }

  //   if (stateKey === 'discounts') {
  //     discounts[id] = value;
  //     setDiscounts({ ...discounts });
  //   } else if (stateKey === 'loadings') {
  //     loadings[id] = value;
  //     setLoadings({ ...loadings });
  //   }

  // }

  function clearResponse() {
    setResponse(prev => {
      return { ...prev, [id]: null };
    });
  }

  // const computedRatesMemo = useMemo(() => getComputedRates(), []);

  const getComputedRatesMemo = _.memoize(getComputedRates);

  function getRate(clientIndex, plan) {
    const computedRates = getComputedRatesMemo();

    if (!computedRates) {
      return;
    }

    if (specificCurrency[id] !== computedRates?.[clientIndex]?.currency) {
      return '-';
    }

    return computedRates?.[clientIndex]?.[plan];
  }

  function getRateForExpandedTable(clientIndex, deductible, plan) {
    const computedRates = getComputedRatesMemo();

    if (!computedRates) {
      return;
    }

    if (specificCurrency[id] !== computedRates?.[clientIndex]?.currency) {
      return '-';
    }

    return computedRates?.[clientIndex]?.rates_per_deductibles?.[deductible]?.[plan];
  }

  function getRateSubTotalForExpandedTable(deductible, plan) {
    const computedRates = getComputedRatesMemo();

    if (!computedRates) {
      return;
    }

    if (specificCurrency[id] !== computedRates?.[0]?.currency) {
      return '-';
    }

    let subTotal = 0;

    for (let i = 0; i < clients.length; i++) {
      const rate = computedRates?.[i]?.rates_per_deductibles?.[deductible]?.[plan];

      if (isNaN(rate)) {
        continue;
      }

      subTotal += rate;
    }

    return subTotal;
  }

  function getCurrency() {
    const computedRates = getComputedRatesMemo();

    if (!computedRates) {
      return;
    }

    if (computedRates.length > 0) {
      return computedRates[0].currency;
    }

    return 'USD';
  }

  function getColorForDeductible(index) {
    const colors = ['#f7f2de', '#f7fcff', '#ccdcc8', '#f7fcff', '#f7f2de', '#e0d095', '#f7f2de'];

    return colors[index % colors.length];
  }

  function getColorForDeductible1(index) {
    const colors = ['#dcd6d6', '#e1e6e9'];

    return colors[index % colors.length];
  }

  const handleMouseDown = (row, col) => {
    setIsSelecting(true);
    setStartCell({ row, col });
    setEndCell({ row, col });
  };

  const handleMouseOver = (row, col) => {
    if (isSelecting) {
      setEndCell({ row, col });
    }
  };

  const handleMouseUp = () => {
    setIsSelecting(false);
  };

  const isCellSelected = (row, col) => {
    if (!startCell || !endCell) return false;
    const rowStart = Math.min(startCell.row, endCell.row);
    const rowEnd = Math.max(startCell.row, endCell.row);
    const colStart = Math.min(startCell.col, endCell.col);
    const colEnd = Math.max(startCell.col, endCell.col);

    return row >= rowStart && row <= rowEnd && col >= colStart && col <= colEnd;
  };


  return (
    <Box id={id} sx={sx}>
      <Paper sx={{ borderColor: '#e0e0e0', borderWidth: 2, pb: 2, scrollMarginTop: '200px' }} variant='outlined' ref={containerRef}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#0c1b4e', px: 2, py: 1 }}>
          <div style={{
            color: '#fff',
            backgroundColor: '#0369ae',
            width: 100,
            height: 60,
            padding: 6,
            fontFamily: 'Poppins, sans-serif',
            fontSize: 13,
            lineHeight: 1.2,
          }}>Lifeline</div>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <img src={`${process.env.PUBLIC_URL}/images/Raffles Health Insurance.png`} alt="Raffles Health Insurance" style={{ height: 60, userSelect: 'none', WebkitUserDrag: 'none' }} draggable={false} onContextMenu={(e) => e.preventDefault()} />
            <img src={`${process.env.PUBLIC_URL}/images/BUPA Blue Logo.png`} alt="BUPA" style={{ height: 60, userSelect: 'none', WebkitUserDrag: 'none' }} draggable={false} onContextMenu={(e) => e.preventDefault()} />
          </Box>
        </Box>
        <Box sx={{ p: 2 }}>
          {/* <Grid container alignItems='center'>
            <Grid container alignItems='center'>
              <Grid item xs={1} mr={2}><Typography fontSize={18} fontWeight={600}>Select Plan</Typography></Grid>

              <Grid item xs={1} mr={2}>
                <FormControlLabel control={<SelectPlanCheckbox onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='lifeline_essential' />} label="Essential" />
              </Grid>
              <Grid item xs={1} mr={2}>
                <FormControlLabel control={<SelectPlanCheckbox onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='lifeline_classic' />} label="Classic " />
              </Grid>
              <Grid item xs={1} mr={2}>
                <FormControlLabel control={<SelectPlanCheckbox onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='lifeline_gold' />} label="Gold" />
              </Grid>

              <Grid item xs={1}>
                <Typography fontSize={18} fontWeight={600}>Optional</Typography>
              </Grid>
              <Grid item xs={1} mr={2}>
                <FormControlLabel control={<Checkbox checked={assistanceCovers.evacuation}
                  onChange={(e) => {
                    setAssistanceCovers({ ...assistanceCovers, evacuation: e.target.checked });

                    scrollToView();
                  }} />}
                  label="Evacuation" />
              </Grid>
              <Grid item xs={1} mr={2}>
                <FormControlLabel control={<Checkbox checked={assistanceCovers.repatriation}
                  onChange={(e) => {
                    setAssistanceCovers({ ...assistanceCovers, repatriation: e.target.checked });
                    setTimeout(() => {
                      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 200);
                  }} />}
                  label="Repatriation" />
              </Grid>
            </Grid>
            <Grid item xs={1} mr={2}><Typography fontSize={18} fontWeight={600}>Deductible</Typography></Grid>
            <Grid item xs={2}>
              <CustomSelect2
                value={deductibles['lifeline']}
                onChange={handleDeductibleChange}
                items={appConfig.content.deductibles.lifeline[currency]}
                disabled={loadingStatus['lifeline']}
              />
            </Grid>
            <Grid item xs={1.5} mr={2}><Typography fontSize={18} fontWeight={600}>Area Of Coverage</Typography></Grid>
            <Grid item xs={2}>
              <Select
                size='small'
                value={specificAreaOfCoverage[id]}
                onChange={(e) => {
                  specificAreaOfCoverage[id] = e.target.value;
                  setSpecificAreaOfCoverage({ ...specificAreaOfCoverage });

                  addToPendingTasks([id]);
                }}
                sx={{ fontSize: 12, height: 40, width: '190px' }}
                fullWidth
                disabled={loadingStatus[id]}
              >
                <MenuItem value={'parent'} sx={{ color: colors.blue[500] }}>{areaOfCoverage}</MenuItem>
                {
                  specific_area_of_coverages && specific_area_of_coverages.map(area_of_coverage => (
                    <MenuItem sx={{ display: areaOfCoverage === area_of_coverage ? 'none' : 'block' }} key={area_of_coverage} value={area_of_coverage}>{area_of_coverage}</MenuItem>
                  ))
                }

              </Select>
            </Grid>
            <Grid item xs={1.5} mr={2}><Typography fontSize={18} fontWeight={600}>Renewal/Further Discount</Typography></Grid>
            <Grid item xs={1}>
              <TextField
                size='small'
                sx={{ width: '80px', textAlign: 'end' }}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
                value={discounts[id]}
                onChange={onInputDiscountChange}
              />
            </Grid>
          </Grid> */}

          <Box sx={{ display: 'flex', gap: 5 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={15} fontWeight={600}>Plan Type</Typography>
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='lifeline_essential' />} label="Essential" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='lifeline_classic' />} label="Classic" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='lifeline_gold' />} label="Gold" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={15} fontWeight={600}>Assistance Cover</Typography>
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<Checkbox size="small" checked={assistanceCovers.evacuation}
                onChange={(e) => {
                  setAssistanceCovers({ ...assistanceCovers, evacuation: e.target.checked });

                  scrollToView();
                }} />}
                label="Evacuation" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<Checkbox size="small" checked={assistanceCovers.repatriation}
                onChange={(e) => {
                  setAssistanceCovers({ ...assistanceCovers, repatriation: e.target.checked });
                  setTimeout(() => {
                    containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }, 200);
                }} />}
                label="Repatriation" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Deductible Option</Typography>
                <CustomSelect2
                  dense
                  value={deductibles['lifeline']}
                  onChange={handleDeductibleChange}
                  items={appConfig.content.deductibles.lifeline[specificCurrency[id]]}
                  disabled={loadingStatus['lifeline']}
                  sx={{ minWidth: 170 }}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Area Of Coverage</Typography>
                <Select
                  size='small'
                  value={specificAreaOfCoverage[id]}
                  onChange={(e) => {
                    specificAreaOfCoverage[id] = e.target.value;
                    setSpecificAreaOfCoverage({ ...specificAreaOfCoverage });

                    // clearResponse();

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    specific_area_of_coverages && specific_area_of_coverages.map(area_of_coverage => (
                      <MenuItem key={area_of_coverage} value={area_of_coverage} sx={{ fontSize: 12 }}>{area_of_coverage}</MenuItem>
                    ))
                  }

                </Select>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Currency</Typography>
                <Select
                  size='small'
                  value={specificCurrency[id]}
                  onChange={(e) => {
                    specificCurrency[id] = e.target.value;
                    setSpecificCurrency({ ...specificCurrency });

                    // clearResponse();

                    setDeductibles(prev => {
                      return {
                        ...prev,
                        [id]: getSafe(() => appConfig.content.deductibles.lifeline[specificCurrency[id]][0])
                      };
                    });


                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    currencies && currencies.map(currency => (
                      <MenuItem key={currency} value={currency} sx={{ fontSize: 12 }}>{currency}</MenuItem>
                    ))
                  }

                </Select>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Payment Frequency</Typography>
                <Select
                  size='small'
                  value={specificPaymentFrequency[id]}
                  onChange={(e) => {
                    specificPaymentFrequency[id] = e.target.value;
                    setSpecificPaymentFrequency({ ...specificPaymentFrequency });

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    ["Annually", "Semi Annually", "Quarterly", "Monthly"].map(payment_frequency => (
                      <MenuItem key={payment_frequency} value={payment_frequency} sx={{ fontSize: 12 }}>{payment_frequency}</MenuItem>
                    ))
                  }

                </Select>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Renewal/Further Discount</Typography>
                <PercentInput
                  value={discounts[id]}
                  onCommit={(value) => setDiscounts(prev => ({ ...prev, [id]: value }))}
                />
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Renewal/Further Loading</Typography>
                <PercentInput
                  value={loadings[id]}
                  onCommit={(value) => setLoadings(prev => ({ ...prev, [id]: value }))}
                />
              </Box>
            </Box>
          </Box>




          <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'end', width: '100%', marginBottom: 7, marginTop: 24 }}>
            {/* <Button
              endIcon={<FactCheckIcon />}
              size="small"
              variant="outlined"
              style={{ marginRight: 7 }}
              onClick={() => {
                setOpenTableOfBenefitsDialog(true)
                fetchTOB_Data({ specific_plans: ['lifeline_essential', 'lifeline_classic', 'lifeline_gold'], include_rates: false, fetch_for_specific_insurer: true });
              }}
            >
              Table Of Benefits
            </Button> */}

            <TableOfBenefitsDialog
              open={openTableOfBenefitsDialog}
              onClose={() => setOpenTableOfBenefitsDialog(false)}
              tableOfBenefits={tableOfBenefits}
              isLoading={fetchingTOB_Data}
            />
            <TableViewModeToggleButton
              id={id}
              isExpandedApiRequestPerInsurers={isExpandedApiRequestPerInsurers}
              setIsxpandedApiRequestPerInsurers={setIsxpandedApiRequestPerInsurers}
              addToPendingTasks={() => { }} // don't add to pending tasks
              style={{ marginRight: 7, fontSize: 11, padding: '2px 8px', minHeight: 0 }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
            <CopyExcelDataButton
              elementId='table-lifeline-rates'
              style={{
                marginRight: 7, fontSize: 11, padding: '2px 8px', minHeight: 0
              }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
            <CopyImageButton
              elementId='table-lifeline-rates'
              setShowImageCopy={setShowImageCopy}
              style={{ fontSize: 11, padding: '2px 8px', minHeight: 0 }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
          </div>
          <TableContainer component={Paper} style={{ width: 'auto', overflowX: 'auto' }}>
            <Table id='table-lifeline-rates' size='small' style={{ background: '#fff', width: `calc(100% + ${clients.length > 5 ? clients.length - 5 : 0} * 75px)` }} >
              <TableHead>
                <TableRow style={{ backgroundColor: isExpandedApiRequestPerInsurers[id] ? '#0c1b4e' : '#0c1b4e' }}>
                  <TableCell color="rgb(255, 255, 255)" colSpan={isExpandedApiRequestPerInsurers[id] ? 2 : 1} style={{ width: isExpandedApiRequestPerInsurers[id] ? 260 : 200, fontWeight: 600, color: 'rgb(255, 255, 255)' }}>Plan</TableCell>
                  {
                    clients.map((client, idx) => {
                      if (client.full_name.trim() === '') {
                        return <TableCell color="rgb(255, 255, 255)" style={{ width: 200, fontWeight: 600, color: 'rgb(255, 255, 255)' }} key={idx}>_</TableCell>
                      }

                      return <TableCell color="rgb(255, 255, 255)" style={{ width: 200, fontWeight: 600, color: 'rgb(255, 255, 255)' }} key={idx}><div>{client.full_name} ({client.age})</div><div>{client.country_of_residence}</div>  </TableCell>
                    })
                  }
                  <TableCell color="rgb(255, 255, 255)" style={{ fontWeight: 600, color: 'rgb(255, 255, 255)' }}>Subtotal</TableCell>
                </TableRow>


              </TableHead>
              {
                isExpandedApiRequestPerInsurers[id] ?
                  (<TableBody>
                    {

                      appConfig.content.deductibles.lifeline[specificCurrency[id]].map((deductible, index) => {
                        return <>
                          <TableRow>
                            <TableCellText style={{ width: 100, minWidth: 100 }} content='Essential' bgColor={getColorForDeductible(index)} />
                            <TableCellText style={{ width: 120, minWidth: 120 }} content={deductible} rowSpan={3} bgColor={getColorForDeductible1(index)} />
                            {
                              clients.map((client, idx) => {
                                return <TableCellRate
                                  key={client.uid}
                                  rate={getRateForExpandedTable(idx, deductible, 'essential')}
                                  currency={getCurrency()}
                                  isLoading={loadingStatus[id]}
                                  bgColor={getColorForDeductible(index)}
                                />;
                              })
                            }
                            <TableCellRate
                              rate={getRateSubTotalForExpandedTable(deductible, 'essential')}
                              currency={getCurrency()}
                              isLoading={loadingStatus[id]}
                              bgColor={getColorForDeductible(index)}
                            />

                          </TableRow>
                          <TableRow>
                            <TableCellText content='Classic' bgColor={getColorForDeductible(index)} />
                            {
                              clients.map((client, idx) => {
                                return <TableCellRate
                                  key={client.uid}
                                  rate={getRateForExpandedTable(idx, deductible, 'classic')}
                                  currency={getCurrency()}
                                  isLoading={loadingStatus[id]}
                                  bgColor={getColorForDeductible(index)}
                                />;
                              })
                            }
                            <TableCellRate
                              rate={getRateSubTotalForExpandedTable(deductible, 'classic')}
                              currency={getCurrency()}
                              isLoading={loadingStatus[id]}
                              bgColor={getColorForDeductible(index)}
                            />
                          </TableRow>
                          <TableRow>
                            <TableCellText content='Gold' bgColor={getColorForDeductible(index)} />
                            {
                              clients.map((client, idx) => {
                                return <TableCellRate
                                  key={client.uid}
                                  rate={getRateForExpandedTable(idx, deductible, 'gold')}
                                  currency={getCurrency()}
                                  isLoading={loadingStatus[id]}
                                  bgColor={getColorForDeductible(index)}
                                />;
                              })
                            }
                            <TableCellRate
                              rate={getRateSubTotalForExpandedTable(deductible, 'gold')}
                              currency={getCurrency()}
                              isLoading={loadingStatus[id]}
                              bgColor={getColorForDeductible(index)}
                            />
                          </TableRow>

                        </>
                      })
                    }
                    <TableRow>
                      <TableCellText content={<div>&nbsp;</div>} colSpan={3 + clients.length} bgColor='#0c1b4e' />
                    </TableRow>
                    <TableRow>
                      <TableCellText content='Evacuation' colSpan={2} bgColor='#e0d095' />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, 'evacuation')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                            bgColor='#e0d095'
                          />;
                        })
                      }

                      <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName='evacuation'
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        bgColor='#e0d095'
                        specificCurrency={specificCurrency[id]}
                      />
                    </TableRow>
                    <TableRow>
                      <TableCellText content='Repatriation' colSpan={2} bgColor='#e0d095' />
                      {
                        clients.map((client, idx) => {
                          return <TableCellRate
                            key={client.uid}
                            rate={getRate(idx, 'repatriation')}
                            currency={getCurrency()}
                            isLoading={loadingStatus[id]}
                            bgColor='#e0d095'
                          />;
                        })
                      }

                      <TableCellRateSubtotalPerPlan
                        computedRates={getComputedRatesMemo()}
                        planName='repatriation'
                        currency={getCurrency()}
                        isLoading={loadingStatus[id]}
                        bgColor='#e0d095'
                        specificCurrency={specificCurrency[id]}
                      />
                    </TableRow>
                  </TableBody>)
                  :
                  (<TableBody>
                    {
                      selectedPlans.includes('lifeline_essential') &&
                      <TableRow>
                        <TableCellText content='Essential' style={{ width: 200, minWidth: 200 }} />
                        {
                          clients.map((client, idx) => {
                            return <TableCellRate
                              key={client.uid}
                              rate={getRate(idx, 'essential')}
                              currency={getCurrency()}
                              isLoading={loadingStatus[id]}
                            />;
                          })
                        }

                        <TableCellRateSubtotalPerPlan
                          computedRates={getComputedRatesMemo()}
                          planName='essential'
                          currency={getCurrency()}
                          isLoading={loadingStatus[id]}
                          specificCurrency={specificCurrency[id]}
                        />
                      </TableRow>
                    }



                    {
                      selectedPlans.includes('lifeline_classic') &&
                      <TableRow>
                        <TableCellText content='Classic' style={{ width: 200, minWidth: 200 }} />
                        {
                          clients.map((client, idx) => {
                            return <TableCellRate
                              key={client.uid}
                              rate={getRate(idx, 'classic')}
                              currency={getCurrency()}
                              isLoading={loadingStatus[id]}
                            />;
                          })
                        }

                        <TableCellRateSubtotalPerPlan
                          computedRates={getComputedRatesMemo()}
                          planName='classic'
                          currency={getCurrency()}
                          isLoading={loadingStatus[id]}
                          specificCurrency={specificCurrency[id]}
                        />
                      </TableRow>
                    }



                    {
                      selectedPlans.includes('lifeline_gold') &&
                      <TableRow>
                        <TableCellText content='Gold' style={{ width: 200, minWidth: 200 }} />
                        {
                          clients.map((client, idx) => {
                            return <TableCellRate
                              key={client.uid}
                              rate={getRate(idx, 'gold')}
                              currency={getCurrency()}
                              isLoading={loadingStatus[id]}
                            />;
                          })
                        }

                        <TableCellRateSubtotalPerPlan
                          computedRates={getComputedRatesMemo()}
                          planName='gold'
                          currency={getCurrency()}
                          isLoading={loadingStatus[id]}
                          specificCurrency={specificCurrency[id]}
                        />
                      </TableRow>
                    }
                    {
                      (assistanceCovers.evacuation || assistanceCovers.repatriation) &&
                      <TableRow sx={{ backgroundColor: '#ffffff' }}>
                        <TableCell colSpan={clients.length + 2} sx={{ fontWeight: 600, background: '#fff' }}>Optional</TableCell>
                      </TableRow>
                    }



                    {
                      assistanceCovers.evacuation &&
                      <TableRow>
                        <TableCellText content='Evacuation' style={{ width: 200, minWidth: 200 }} />
                        {
                          clients.map((client, idx) => {
                            return <TableCellRate
                              key={client.uid}
                              rate={getRate(idx, 'evacuation')}
                              currency={getCurrency()}
                              isLoading={loadingStatus[id]}
                            />;
                          })
                        }

                        <TableCellRateSubtotalPerPlan
                          computedRates={getComputedRatesMemo()}
                          planName='evacuation'
                          currency={getCurrency()}
                          isLoading={loadingStatus[id]}
                          specificCurrency={specificCurrency[id]}
                        />
                      </TableRow>
                    }



                    {
                      assistanceCovers.repatriation &&
                      <TableRow>
                        <TableCellText content='Repatriation' style={{ width: 200, minWidth: 200 }} />
                        {
                          clients.map((client, idx) => {
                            return <TableCellRate
                              key={client.uid}
                              rate={getRate(idx, 'repatriation')}
                              currency={getCurrency()}
                              isLoading={loadingStatus[id]}
                            />;
                          })
                        }

                        <TableCellRateSubtotalPerPlan
                          computedRates={getComputedRatesMemo()}
                          planName='repatriation'
                          currency={getCurrency()}
                          isLoading={loadingStatus[id]}
                          specificCurrency={specificCurrency[id]}
                        />
                      </TableRow>
                    }





                    {/* <TableRatesRow
                  planId='lifeline_essential'
                  planName='essential'
                  planLabel='Essential'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  bgColor='#bbdefb'
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('lifeline_essential')}
                /> */}

                    {/* <TableRatesRow
                  planId='lifeline_classic'
                  planName='classic'
                  planLabel='Classic'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  bgColor='#bbdefb'
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('lifeline_classic')}
                /> */}

                    {/* <TableRatesRow
                  planId='lifeline_gold'
                  planName='gold'
                  planLabel='Gold'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  bgColor='#bbdefb'
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('lifeline_gold')}
                /> */}


                    {/* <TableRatesRow
                  planId='lifeline_evacuation'
                  planName='evacuation'
                  planLabel='Evacuation'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  bgColor='#eeeeee'
                  loading={loadingStatus[id]}
                  rates={response ? response.assistance_covers : []}
                  currency={specificCurrency[id]}
                  visible={assistanceCovers.evacuation}
                /> */}
                    {/* 
                <TableRatesRow
                  planId='lifeline_repatriation'
                  planName='repatriation'
                  planLabel='Repatriation'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  bgColor='#eeeeee'
                  loading={loadingStatus[id]}
                  rates={response ? response.assistance_covers : []}
                  currency={specificCurrency[id]}
                  visible={assistanceCovers.repatriation}
                /> */}
                  </TableBody>
                  )
              }
            </Table>

          </TableContainer>

          <NotesDisplay appConfig={appConfig} insurerId={id} />

          <RatesVersionSelect
            insurer={id}
            label="Rates Version"
            insurerRates={insurerRates}
            selectedRatesVersion={selectedRatesVersion}
            setSelectedRatesVersion={setSelectedRatesVersion}
            disabled={loadingStatus[id]}
            handleFetchAppConfig={handleFetchAppConfig}
            onChange={() => setShowRefreshNow(true)}
          />

        </Box>


      </Paper>
    </Box>
  );
});

export default Lifeline_Rates;